import React from 'react';
import PropTypes from 'prop-types';
import VisibilitySensor from 'react-visibility-sensor';

export default class ScrollLazyLoad extends React.Component {

  constructor(props) {
    super(props);

    this.state = { active: true };

    this.containment = document.querySelector(props.container) || document.body;
    if (props.viewportOffset) {
      const offset = this.containment?.clientHeight * props.viewportOffset;
      this.offset = { bottom: -offset };
    }

    // eslint-disable-next-line custom/no-unsafe-deep-access
    this.load = this.load.bind(this);
  }

  load(isVisible) {
    if (isVisible) {
      const keepAlive = this.props.load();
      this.setState({ active: keepAlive });
    }
  }

  render() {
    return this.state.active ? (
      <VisibilitySensor
        onChange={this.load}
        partialVisibility={true}
        delayedCall={true}
        scrollCheck={true}
        offset={this.offset}
        containment={this.containment}
      />
    ) : null;
  }
}

ScrollLazyLoad.propTypes = {
  load: PropTypes.func.isRequired,
  viewportOffset: PropTypes.number,
  container: PropTypes.string,
};
